import React from 'react'
import warning from "../../../assets/img/Models/warning.svg";


const InvalidCodesModal = ({
    storedDETData
}) => {
    return (
        <div className='text-center'>
            <div>
                <img
                    src={warning}
                    className="mb-3"
                    style={{
                        width: "4rem"
                    }}
                />
            </div>
            <p className='label mt-4'>Not all DET Codes were uploaded successfully.</p>
            <div className='det-upload-code-date mt-4'>
                <label className='label'>Successful uploaded: {storedDETData.valid_count} </label>
                <label className='label'>Failed uploaded: {storedDETData.invalid_count}</label>
            </div>
            <p className='mt-4 note-det-code-text'>
                Please download the failure file and retry after <br />
                making the necessary changes. {" "}
                <a href={storedDETData.invalid_codes_download_url}>
                    error.xlxs
                    <i class="fa fa-download ml-1"></i>
                </a>
            </p>
            <style jsx>{`
                .det-upload-code-date{
                    padding: 20px 20px;
                    border: 1px solid #E2E2E2;
                    border-radius: 5px;
                    background: #F8F8F8;
                }

                .note-det-code-text{
                    font-family: Hind;
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 24.02px;
                    color: #6D7780;
                }
             `}</style>
        </div>
    )
}

export default InvalidCodesModal;